<template>
  <dashboard-admin class="mt-4" v-if="roleVal == 'admin' || roleVal == 'staff'"/>
  <dashboard-vendor class="mt-4" v-else-if="roleVal == 'vendor'"/>
  <dashboard-tenant class="mt-4" v-else-if="roleVal == 'tenant'"/>
</template>

<script>
import DashboardAdmin  from './DashboardAdmin.vue'
import DashboardVendor  from './DashboardVendor.vue'
import DashboardTenant  from './DashboardTenant.vue'
import axios from '@/axios'
const jwt = require('jsonwebtoken')

export default {
  components: {
    DashboardAdmin,
    DashboardVendor,
    DashboardTenant
  },
  data () {
    return {
      token: localStorage.usertoken,
      roleVal: ''
    }
  },
  methods: {
    async loadUser(){
      var decoded = jwt.verify(this.token, 'secret')  
      const viewId = decoded.id
      var d = await axios.get(`/user/view/${viewId}`, {
        headers: { 'Authorization': this.token }
      }) 
      const userD = d['data'][0]['user_role']['val']
      this.roleVal = userD
    },
  },
  created () {
    this.loadUser()
  }
}
</script>